import { Pipe, PipeTransform } from '@angular/core';
import {InternationalizationService} from "../../core/services/internationalization/internationalization.service";

@Pipe({
  name: 'getFieldName',
})
export class GetFieldNamePipe implements PipeTransform {

  constructor(private i18nService: InternationalizationService){}

  transform(fieldName: string) {
    const [table, field] = fieldName.split(".");
    const def = (window as any).TableManager.getTableDefinition(table);
    const i18nKey = def.getField(field).getI18nKey();
    return this.i18nService.getMessage(i18nKey);
  }}
